import angular from 'angular';
import moment from 'moment';
import URLS from 'Helpers/urls';

(function() {
    'use strict';

    angular.module('app').component('rescheduleModal', {
        template: require('./reschedule-modal.html'),
        controller: RescheduleModalCtrl,
        controllerAs: 'vm',
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }
    });

    RescheduleModalCtrl.$inject = [
        '$scope',
        '$cookies',
        '$timeout',
        '$location',
        'QueryService',
        'LanguageService',
        'logger'
    ];

    function RescheduleModalCtrl($scope, $cookies, $timeout, $location, QueryService, LanguageService, logger) {
        var vm = this;
        vm.content = null;
        vm.strings = LanguageService.strings;

        vm.scheduled_date = moment().utcOffset('+9:00');
        vm.data = {};
        vm.hours_list = [];
        vm.clicked_days = [];
        vm.init_filters = init_filters;

        vm.days = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'].map((s, i) => {
            return { day: s, index: i };
        });

        init_filters();
        function init_filters() {
            vm.mornings = [6, 7, 8, 9, 10, 11].map(s => {
                return { time: `${`${s}`.padStart(2, '0')}:00`, hour: s };
            });
            vm.afternoons = [12, 13, 14, 15, 16, 17].map(s => {
                return { time: `${`${s}`.padStart(2, '0')}:00`, hour: s };
            });
            vm.evenings = [18, 19, 20, 21, 22, 23, 24].map(s => {
                return { time: `${`${s}`.padStart(2, '0')}:00`, hour: s };
            });

            vm.time_group_names = [
                vm.strings.BOOK_MORNING,
                vm.strings.BOOK_AFTERNOON,
                vm.strings.BOOK_EVENING
            ];

            vm.time_group_symbols = ['fa fa-sun', 'fa fa-coffee', 'fa fa-moon'];
            vm.time_groups = [vm.mornings, vm.afternoons, vm.evenings];
            vm.selected_times = [];
            vm.selected_tags = [];
            vm.days.forEach(d => d.selected = 0);
        }


        get({ tag: '' }, 'tag', {}, () => {});

        function get(route, store, params, cb) {
            var request = {
                method: 'GET',
                route: route,
                params,
                params,
                cache_string: ''
            };

            vm.loading = true;

            QueryService.query(request).then(
                function(response) {
                    vm.data[store] = response.data.data;
                    setTimeout(() => {
                        vm.loading = false;
                        $scope.$apply();
                    }, 2000);

                    if (cb) cb();
                },
                function(err) {
                    logger.error(err.message, '');
                }
            );
        }
        vm.select_time = (time, minute) => {
            const t = time.time.split(':')[0] + ':' + minute;

            if (vm.selected_times.includes(t)) {
                vm.selected_times.splice(vm.selected_times.indexOf(t), 1);
            } else {
                vm.selected_times.push(t);
            }
        };

        vm.is_time_selected = time => {
            let selected = false;
            vm.selected_times.forEach(t => {
                if (t.split(':')[0] === time.time.split(':')[0]) {
                    selected = true;
                }
            });

            return selected;
        };

        vm.$onInit = function() {
            vm.content = angular.copy(vm.resolve.content);
            vm.page = vm.content.page;
            vm.teacher = vm.content.teacher;
            vm.minutes_per_class = vm.teacher.minutes_per_class;
            vm.cb = vm.content.cb;


            vm.email = vm.content.email;
            vm.name = vm.content.name;

            vm.certificates = get_certificates(vm.teacher.certificates || '{}');
            vm.is_regular = vm.teacher.is_regular;
            if(vm.page === 1){
                retrieve_teachers();
            }else{
                retrieve_schedules();
            }


            // recommended teachers
            vm.recommended_labels = [
                '-1 Hour',
                'Same Schedule',
                '+1 Hour'
            ];
            vm.recommended_labels2 = [
                'This teacher is available 1 Hour before your schedule',
                'This teacher is available with the same schedule as your current teacher',
                'This teacher is available 1 Hour after your schedule',
            ];
            const time = moment(vm.teacher.start).utcOffset('+09:00').format('HH:mm');
            const _time = parseInt(time.split(':')[0]) * 4 + parseInt(parseInt(time.split(':')[1]/15))/4
            vm.teacher.days.split('').forEach(d => {
                vm.days[d].selected = true;
            })

            vm.retrieve_available_schedules();

            const keys = ['tn1', 't0', 't1'];
            keys.forEach((key, i) => {

                get({ teacher: 'schedule' }, key, {
                    days: vm.teacher.days,
                    time: _time,
                    offset: i-1,
                    duration: vm.minutes_per_class
                }, () => {
                    if(vm.data[key] && vm.data[key].items)
                    vm.data[key] = vm.data[key].items[parseInt(Math.random() * vm.data[key].items.length)];
                    console.log(vm.data);
                });
            })
            
        };

        vm.select_tag = (tag, outside) => {
            if (outside) {
                // init_filters();
                vm.filter = 0;
                if (vm.selected_tags_outside.includes(tag.english_text)) {
                    vm.selected_tags_outside.splice(
                        vm.selected_tags_outside.indexOf(tag.english_text),
                        1
                    );
                } else {
                    vm.selected_tags_outside.push(tag.english_text);
                }
                vm.apply_filters();
            } else {
                vm.selected_tags_outside = [];

                if (vm.selected_tags.includes(tag.english_text)) {
                    vm.selected_tags.splice(
                        vm.selected_tags.indexOf(tag.english_text),
                        1
                    );
                } else {
                    vm.selected_tags.push(tag.english_text);
                }
            }
        };

        vm.apply_filters = () => {

            const days = vm.days.filter(s => s.selected).map(s => s.index);
            const times = vm.selected_times.map(s => {
                const t = s.split(':').map(s => parseInt(s));
                const hour = parseInt(t[0]) * 4;
                const minute = t[1] / 15;

                return hour + minute;
            });

            const tags = []
                .concat(vm.selected_tags)
                .concat(vm.selected_tags_outside);

            console.log(times);
            console.log(days);
            console.log(tags);

            vm.filters = {
                times,
                days,
                tags
            };

            vm.data.all_teachers = { items: [] };
            vm.all_page = 0;

            vm.loading = true;
            see_more_all(() => {
                setTimeout(() => {
                    document.getElementById('all_scroll').scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }, 250);
                setTimeout(() => {
                    vm.loading = false;
                    $scope.$apply();
                }, 2000);

                // document
                //     .getElementById('all_scroll')
                //     .scrollIntoView(true)
            });
        };
        vm.loading = true;

        function see_more_all(cb) {
            const top_params = {
                sort_key: 'position',
                sort_mode: 'DESC',
                has_profile_card: 'DESC',
                page: ++vm.all_page,
                limit: 27,
                keyword: vm.search,
                status: 'ACTIVE',
                filters: JSON.stringify(vm.filters)
            };

            var request = {
                method: 'GET',
                params: top_params,
                hasFile: false,
                route: URLS.base + `/teacher/cust`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.teachers = response.data.data.items;
                        vm.loading = false;
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                });
        }


        function get_certificates(cert) {
            const certificates = [];
            const _certificates = JSON.parse(cert);

            for (const key in _certificates) {
                certificates.push({
                    url: _certificates[key],
                    key
                });
            }

            return certificates.filter(s => s.url);
        }

        vm.to_tag = teacher => {
            return teacher.tags?teacher.tags.split(',').join(', '):'';
        };
        vm.to_tag2 = teacher => {
            if (teacher && teacher.tags) return teacher.tags.split(',');
        };

        vm.view_cert = cert => {
            vm.cert = cert;
            console.log(cert);
        };
        vm.retrieve_teachers = retrieve_teachers;
        function retrieve_teachers(startsWith){

            const query = {
                sort_key:'position'
            };

            if(startsWith){
                query.startsWith = startsWith;
            }
            
            var request = {
                method: 'GET',
                params: query,
                hasFile: false,
                route: URLS.base + `/teacher/cust`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.teachers = response.data.data.items;
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                });
        };
        vm.play_audio = teacher => {
            const a = document.getElementById(teacher.audio_introduction);
            teacher.playing_audio = !teacher.playing_audio;

            if (teacher.playing_audio) {
                a.play();
                set_timer(teacher);
            } else {
                a.pause();
            }
        };
        vm.scroll_audio = teacher => {
            const a = document.getElementById(teacher.audio_introduction);
            const t = teacher.audio_scroll * a.duration;

            clearTimeout(teacher.audio_timer);
            a.currentTime = t;

            if (!teacher.playing_audio) {
                clearTimeout(teacher.audio_timer);
                a.play();
                teacher.playing_audio = true;
            }
        };

        vm.is_time_selected_rc = time => {
            if (vm.selected_rc_time)
                return (
                    vm.selected_rc_time.split(':')[0] == time.time.split(':')[0]
                );
        };

        function set_timer(teacher) {
            const a = document.getElementById(teacher.audio_introduction);

            if (teacher.playing_audio) {
                teacher.audio_timer = setTimeout(() => set_timer(teacher), 100);
            }

            teacher.audio_scroll = a.currentTime / a.duration;
            $scope.$apply();
        }
        vm.tap_teacher = (teacher) => {
            
            vm.page = 2;

            vm.teacher.tags = teacher.tags;

            vm.certificates = get_certificates(teacher.certificates || '{}');

            vm.teacher.teacher_id = teacher.id;
            vm.teacher.name = teacher.name;
            vm.teacher.profile_card = teacher.profile_card;
            vm.has_new_teacher = true;
            retrieve_schedules();
        }
        vm.int_to_days = function(i) {
            return vm.days[parseInt(i)];
        };

        function retrieve_schedules(){

            vm.loading = true;
            var request = {
                method: 'GET',
                route: URLS.base + `/teacher/${ vm.teacher.teacher_id }/regular_class_item`,
                cache: true
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.data = response.data.data;

                        const items = vm.data.free_schedule.filter(s => !s.locked).map(i => {
                            const s = i.hour;
    
                            return (
                                ('' + parseInt(s / 4)).padStart(2, '0') +
                                ':' +
                                ('' + (s % 4) * 15).padStart(2, '0')
                            );
                        });
                        vm.rc_schedule_hours = items;
                        vm.rc_schedule_hours2 = items.map(s => s.split(':')[0]);

                    },
                    function(error) {
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });

            ;
        }

        vm.has_days = ()=>{
            return vm.days.filter(d => d.selected).length > 0;
        }

        vm.select_rc_time = (time, minute) => {
            vm.selected_rc_time = time.time.split(':')[0] + ':' + minute;
            vm.clicked_time_rc = null;

            const t = parseInt(time.time.split(':')[0]) * 4;
            const m = minute / 15;
            vm.available_rc_days = vm.data.free_schedule
                .filter(s => s.hour === t + m)
                .map(s => s.day);
        };

        vm.submit = () => {
            const days = vm.days.filter(s=>s.selected).map(s=>s.index).join('');
            const start = vm.selected_rc_time;
            var s = new Date(`2020-01-01 ${start}`);
            s.setMinutes(s.getMinutes()+vm.minutes_per_class);
            const end = s.format('HH:MM');
            
            
            console.log(start, end);
            console.log(vm.selected_rc_time);
            console.log(days);
            // console.log(overwrites);
            console.log(vm.teacher.class_time);

            if(days.length > 0){

                const overwrites = {};
                days.split('').forEach((h) => {
                    overwrites[h] = {
                        start: start,
                        end: end,
                    };
                });

                
                const data = {
                    start: new Date(),
                    minutes_per_class: vm.minutes_per_class,
                    days: days,
                    offset: 9,
                    prev_class_time: vm.teacher.class_time,
                    next_class_time: start,
                    overwrites: overwrites,
                    reason: vm.teacher.reason
                }

                if(vm.has_new_teacher){
                    data.teacher_id = vm.teacher.teacher_id;
                }

                vm.loading = true;
                var request = {
                    method: 'POST',
                    body: data,
                    params: { email: vm.email, name: vm.name },
                    hasFile: false,
                    route: URLS.base + `/reschedule/` + vm.teacher.regular_class_id,
                    cache: false
                };
    
                QueryService.query(request)
                    .then(
                        function(response) {
                            vm.page = 3;
                            vm.submitted_view = true;
                            if(vm.cb){
                                vm.cb();
                            }
                        },
                        function(error) {
                            logger.errorFormatResponse(error);
                        }
                    )
                    .finally(function() {
                        vm.loading = false;
                    });

            }

        }

        vm.alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
        vm.cancel = () => {
            vm.modalInstance.close();
        };

        vm.goHome = () => {
            vm.modalInstance.close();
            $location.path('home-page');
        };

        
        vm.click_day = day => {
            day.selected = !day.selected;
            vm.retrieve_available_schedules();
        };

        // vm.click_day = (day) => {

        //     if(vm.check_class_lol(day) === 'schedule-unavailable'){
        //         return 'lol';
        //     }

        //     if(day.clicked){
        //         // console.log('vm.clicked_days.indexOf(day)');
        //         // console.log(vm.clicked_days.indexOf(day));
        //         const index = vm.clicked_days.indexOf(day);
        //         vm.clicked_days.splice(index, 1);

        //     }else{
        //         vm.clicked_days.push(day);
        //     }
        //     day.clicked = !day.clicked;
        // }

        vm.check_class_lol = (day)=>{
            if(vm.is_regular && vm.clicked_days.length && vm.clicked_days[0].index !== day.index){
                return 'schedule-unavailable';
            } else if(day.clickable){
                return 'schedule-unavailable'
            } else if (day.clicked){
                return 'clicked_hour'
            }else {
                return 'available';
            }
        };

        function populate_hours(start, end, callback) {
            let start_date = moment(`2018-10-01 ${start}`);
            let end_date = moment(`2018-10-01 ${end}`);
        
            const hours = [];
        
            let index = 0;
            while(end_date.diff(start_date) > 0){
                index = index+1;
                hours.push(generate_hours(start_date, index));
                start_date = start_date.add(vm.minutes_per_class, 'minutes');
            }
        
            hours.push(generate_hours(start_date));
            callback(hours);
        }
        
        function generate_hours(start_date, index){
            const hours = [];
            for(let i = 0; i < 5; i++){
                //clickable is reversed -_- 1 is not clickable..
                const hour = {
                    start: moment(start_date).format('HH:mm'),
                    end: moment(start_date).add(vm.minutes_per_class, 'minutes').format('HH:mm'),
                    day: i+1,
                    index: index,
                    clickable: 1,
                    clickable: check_if_clickable(start_date, i + 1),
                    clicked: false
                };
        
                vm.hours_list.push(hour);
                hours.push(hour);
            }
            return hours;
        }
        
        function check_if_clickable(start_date, _day, callback){
        
            const start = moment(`2018-10-0${_day} ${moment(start_date).format('HH:mm')}`);
            const end   = moment(`2018-10-0${_day} ${moment(start_date).add(vm.minutes_per_class, 'minutes').format('HH:mm')}`);
            //check if regular no regular class
            const start_time = moment(start_date).get('hour')  * 4 + moment(start_date).get('minutes') / 15;
            const end_time = moment(start_date).add(vm.minutes_per_class, 'minutes').get('hour') * 4 + moment(start_date).add(vm.minutes_per_class, 'minutes').get('minutes') / 15;

            const is_open = vm.free_schedule[_day+'|'+parseInt(start_time)] && vm.free_schedule[_day+'|'+parseInt(end_time)];

            if(!is_open){
                return 1;
            }


            // const filtered = vm.available_schedule.filter((item) => {
            const filtered = vm.grouped_schedule[_day].filter((item) => {
        
                const day = moment(item.start).weekday();
                const item_start = moment(`2018-10-0${day === 0? 7: day} ${moment(item.start).utcOffset(9).format('HH:mm')}`);
                const item_end =   moment(`2018-10-0${day === 0? 7: day} ${moment(item.end).utcOffset(9).format('HH:mm')}`);
        
                
                return (
                    start.isBetween(item_start, item_end) || 
                    end.isBetween(item_start, item_end) || 
                    item_start.isBetween(start, end) || 
                    item_end.isBetween(start, end) || (
                        item_start.diff(start) === 0 &&
                        item_end.diff(end) === 0
                    )
                );
        
            });

            // callback(filtered.length);
            return filtered.length;

        }
        
        vm.loading_schedules = 0;
        vm.has_selected_days = 1;
        vm.retrieve_available_schedules = () => {
            const selected = vm.days.filter(s => s.selected);
            vm.has_selected_days = ~~!!selected.length;

            vm.loading_schedules = 1;

            const days = selected.map(s => s.index).join('');
            const duration = Math.ceil(vm.minutes_per_class / 15);

            if (days.length < 1) {
                return;
            }

            get(
                { schedule: days, duration: '' },
                'available_schedules',
                { duration },
                () => {
                    vm.loading_schedules = 0;
                    vm.selected_times = [];
                }
            );
        };

        vm.has_no_available_schedule_parent = time => {
            if (!vm.data.available_schedules) {
                return;
            }
            // console.log(time.hour);
            const available_hours = vm.data.available_schedules.items.map(s =>
                parseInt(s.hour / 4)
            );
            return !available_hours.includes(time.hour);
        };

        vm.has_no_available_schedule_child = (time, index) => {
            if (!vm.data.available_schedules) {
                return;
            }
            // console.log(time.hour*4+index);
            const available_hours = vm.data.available_schedules.items.map(
                s => s.hour
            );

            return !available_hours.includes(time.hour * 4 + index);
        };

    }
})();



// WEBPACK FOOTER //
// ./src/app/components/changes/reschedule-modal.component.js